import { FC, ReactNode } from 'react';

interface TableBodyProps {
    children?: ReactNode;
}

const TableBody: FC<TableBodyProps> = ({ children }) => <tbody>{children}</tbody>;

export default TableBody;
